const CONST = {
    RESET: 'BASE64_TO_IMAGE/RESET',
    UPDATE_STATE: 'BASE64_TO_IMAGE/UPDATE_STATE',
    UPDATE_FILES: 'BASE64_TO_IMAGE/UPDATE_FILES',
};

export default CONST;
